/**
 * Decide whether the current user may enter a route, given its `auth` requirement. Shared by the
 * doctor-app `corePlugin` and patient-app global middleware so route-level role ACL behaves
 * identically across apps. Deny-by-default: a predicate requires both an authenticated user and a
 * truthy result.
 *
 * @__NO_SIDE_EFFECTS__
 */
export function isRouteAuthorized({ auth, user }) {
    if (typeof auth === 'function') {
        return user != null && auth(user);
    }
    // `true` requires an authenticated user; the caller checks authentication separately, so this
    // helper only needs to confirm the predicate passes for the function form.
    return true;
}
//# sourceMappingURL=isRouteAuthorized.js.map